module.exports = __webpack_public_path__ + "img/spain.3dd61f86.png";